export function createElement(elementValue, id, classList) {
    const element = document.createElement(elementValue);
    if(id!==null)
        element.setAttribute('id', id);

    if(classList!==null) {
        for(let i of classList) {
            element.classList.add(i);
        }

    }
    return element;
}

export function createElementNS(uri, elementValue, id, classList) {
    const element = document.createElementNS(uri, elementValue);
    if(id!==null)
        element.setAttribute('id', id);

    if(classList!==null) {
        for(let i of classList) {
            element.classList.add(i);
        }

    }
    return element;
}